import React, { useEffect, useState, Fragment } from 'react'
import DataTable from 'react-data-table-component'
import orderBy from 'lodash/orderBy'

import axiosConfig from '@lib/axiosConfig'

import ModalComponent from '@component/Modal'

import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './custom.css'


const DataTableComponent = ({
    columns,
    url,
    title = '',
    pagination = true,
    subHeader = true,
    expandable = false,
    expandableData,
    selectableRows = false,
    selectableRowsNoSelectAll = false,
    optionsHeaderLeft = '',
    additionalFilter = null,
    dataFromComponent=null
}) => {

    const [loading, setLoading] = useState(true)
    const [modalOpen, setModalOpen] = useState(false)

    const [filter, setFilter] = useState([])
    const [filterInit, setFilterInit] = useState([])
    const [search, setSearch] = useState([])

    const fetchUrl = async () => {
		if(dataFromComponent == null){
			setLoading(true);
			await axiosConfig.get(url)
				.then(response => {
					setFilter(response.data) // lista no datatable

					setSearch(response.data) // campo de busca principal
					setFilterInit(response.data) // limpa os filtros
				})
			setLoading(false);
		}else{
			let data =null;
			if(typeof dataFromComponent.data != 'undefined' ){
				data = dataFromComponent.data;
			}else{
				data = dataFromComponent;
			}
			setFilter(data) // lista no datatable
			setSearch(data) // campo de busca principal
			setFilterInit(data) // limpa os filtros
			setLoading(false);
		}
		
	}

    const searchInput = (option) => {
        let q = option.toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')

        const result = search.filter((item) => {
            return (
                JSON.stringify(item)
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .indexOf(q) > -1
            );
        })

        setFilter(result)
    }

    const filterInput = (column, option) => {
        let q = option.toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

        const result = filter.filter(v =>
            [column].some(prop => v[prop].toString()
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .indexOf(q) > -1
            )
        );

        if (result.length > 0) {
            setFilter(result)
        } else {

            document.getElementById(column).value = '';
            setModalOpen(true);

        }
    }

    const filterCustom = (column, option) => {
        let q = option.toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

        function tratar(value) {
            if (value) {
                return value.toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '') === q
            }
        }

        const result = filter.filter(v =>
            [column].some(prop => tratar(v[prop]))
        );

        if (result.length > 0) {
            setFilter(result)
        } else {

            document.getElementById(column).value = '';
            setModalOpen(true);

        }
    }

    const filterClear = () => {
        document.getElementById('form-filter').reset();
        setFilter(filterInit)
    }

    const ExpandableComponent = () => {
        return <Fragment>{expandableData}</Fragment>;
    }

    const CustomLoader = () => <FontAwesomeIcon icon={faSpinner} spin={true} size='2x' color='#1351B4' />

    const NoDataComponent = () => (
        <div style={{
            alignItems: 'center',
            color: '#4A4B4D',
            display: 'flex',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            padding: '22px 0',
            textAlign: 'center'
        }}>
            Nenhum registro correspondente encontrado
        </div>
    )

    const customSort = (rows, field, direction) => {
        const handleField = row => {
            if (row[field]) { return row[field]; }
            return row[field];
        }
        return orderBy(rows, handleField, direction);
    };

    const OptionsHeader = () => {
        return <Fragment>{optionsHeaderLeft}</Fragment>
    }

    let componentFilter = null
    if (additionalFilter) {
        const FilterComponent = require(`./filtros/` + additionalFilter).default;
        componentFilter = <FilterComponent
            functionInput={filterInput}
            functionFilter={filterCustom}
            functionClear={filterClear}
        />
    }

    const modalSim = (event, value) => {
        setModalOpen(false)
    }

    useEffect(() => {
        fetchUrl()
    }, [dataFromComponent])


    return (

        <div id='datatable_component'>
            {componentFilter}

            <DataTable
                columns={columns}
                data={filter}
                direction='auto'

                // expandableRows [true/false] exibe a linha extra, abaixo da linha selecionada
                expandableRows={expandable}

                // expandableRowsComponent (conteúdo da linha extra)
                expandableRowsComponent={<ExpandableComponent />}

                // fixedHeader (fixa o cabeçalho ao rolar o conteúdo da tabela)
                fixedHeader={false}

                // highlightOnHover (destacada a linha ao passar o mouse)
                highlightOnHover={true}

                // pagination (exibe a paginação)
                pagination={pagination}

                // paginaçãoPorPágina (quatidade de registros por página, carregada inicialmente)
                paginationPerPage={10}

                // paginationRowsPerPageOptions (opções de seleção suspensa de página de linha)
                paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}

                // paginationComponentOptions (substitua as opções do componente de paginação integrado.)
                paginationComponentOptions={paginationComponentOptions}

                persistTableHead={true}
                progressPending={loading}
                progressComponent={<CustomLoader />}
                noDataComponent={<NoDataComponent />}
                noHeader
                responsive={false}

                // selectableRows (exibe o checkbox de cada linha)
                selectableRows={selectableRows}

                // selectableRows (exibe a mensagem ao selecionar)
                selectableRowsHighlight={false}

                // selectableRowsNoSelectAll [true/false] oculta o checkbox que seleciona todos os outros
                selectableRowsNoSelectAll={selectableRowsNoSelectAll}

                sortFunction={customSort}

                subHeader={subHeader}
                subHeaderAlign='center'
                subHeaderComponent={
                    <Fragment>
                        <div className='col mb-3'>
                            {title ? (

                                <span
                                    style={{
                                        color: '#000',
                                        lineHeight: '22px',
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        fontStyle: 'normal',
                                    }}
                                >{title}</span>

                            ) : <OptionsHeader />}
                        </div>

                        <div className='col mb-3'>
                            <input
                                type='text'
                                placeholder={'O que você procura?'}
                                className='form-control datatable-search'
                                onChange={(e) => searchInput(e.target.value)}
                            />
                        </div>
                    </Fragment>
                }
                subHeaderWrap
            />


            {modalOpen && <ModalComponent
                variant='simple'
                icon='alert'
                title='Alerta!'
                message={[
                    { 'msg': 'Nenhum resultado encontrado uitlizando o(s) filtro(s)' },
                    { 'msg': 'Limpe os filtros e utilize-os novamente' }
                ]}
                onHide={() => setModalOpen(false)}
                show={modalOpen}
                functionSim={modalSim}
                parametroSim={null}
                tituloBtnSim='Ok'
                functionNao={null}
                parametroNao={null}
                tituloBtnNao={null}
            />}
        </div>

    );
};

const paginationComponentOptions = {
    rowsPerPageText: 'Registros por página ',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todos',
}

export default DataTableComponent;
